module.exports = __webpack_public_path__ + "img/qmsat.c769e5c3.png";